import _ from 'lodash'
import {
  PROPOSAL_TYPE,
  PROPOSAL_PHASE_TYPE
} from '@vzmi/shp_shared_compo/constants/proposal'
import { HyperLink } from '../../../Common/Form'
import ProposalStatusBar from '../../Common/ProposalStatusBar/ProposalStatusBar'
import Tip from '../../Common/Tip'
import {
  UPDATE_PROPOSAL_TYPE,
  UPDATE_PROPOSAL_TYPE_MAP
} from '../helper'
import styles from './index.css'

// 母子提案共同用到的欄位
export const getCommonStatusProps = (proposal, listing) => {
  const proposalProps = _.pick(proposal, [
    'reviewStatus',
    'executeStatus',
    'executedTs',
    'executeResult',
    'declineReason',
    'declineDetail',
    'suggestion'
  ])
  const listingProps = {
    listing: _.pick(listing, ['id'])
  }
  const commonProposalProps = {
    ...proposalProps,
    ...listingProps
  }
  return commonProposalProps
}

export const getTotalProposalStatusList = (listing, subProposalMap) => {
  const proposal = _.get(listing, 'proposal', {})
  const mainProposalStatus = {
    ...getCommonStatusProps(proposal, listing),
    proposalType: PROPOSAL_TYPE.UPDATE_LISTING,
    proposalId: _.get(proposal, 'id')
  }
  const subProposalsStatus = _.flow(
    () => _.get(listing, 'proposal.subProposals', []),
    subProposals => _.map(subProposals, subProposal => {
      const {
        id: proposalId,
        type: proposalType
      } = subProposal
      const currentSubProposal = _.get(subProposalMap, proposalType, {})
      const commonStatusProps = getCommonStatusProps(currentSubProposal, listing)
      return {
        ...commonStatusProps,
        proposalId,
        proposalType
      }
    })
  )()
  // 母提案放第一個，子提案照 API 給的順序排序
  const totalProposalStatusList = [mainProposalStatus, ...subProposalsStatus]
  return totalProposalStatusList
}

// 將母、子提案組成顯示在檢視頁的狀態卡
const SubProposalsStatusBar = props => {
  const { listing, subProposalMap } = props
  const totalProposalStatusList = getTotalProposalStatusList(listing, subProposalMap)
  return (
    <div className={styles.subProposalsStatusBar}>
      {totalProposalStatusList.map(proposalStatus => {
        const {
          proposalId,
          proposalType
        } = proposalStatus
        return (
          <div
            key={proposalType}
            className={styles.subProposalBlock}
          >
            <Tip type='info'>
              修改
              {UPDATE_PROPOSAL_TYPE_MAP[proposalType]}
              提案編號：
              <HyperLink
                target='_blank'
                href={`../${UPDATE_PROPOSAL_TYPE[proposalType]}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?id=${proposalId}`}
              >
                {proposalId}
              </HyperLink>
            </Tip>
            <ProposalStatusBar {...proposalStatus} />
          </div>
        )
      })}
    </div>
  )
}

export default SubProposalsStatusBar
